import httpMixin from "@/v2/mixins/http.js";
import mapperMixin from "@/v2/mixins/mapper.js";
import warehouseMixin from "@/v2/mixins/warehouses.js";
import { CompanyMapperParameter, CompanyFactory } from "@/v2/models/companies.js";

export default {
    mixins: [httpMixin, mapperMixin, warehouseMixin],
    methods: {
        _companyMapper(company) {
            // extract the "custom-{field}" elements from the company object
            const customFields = Object.keys(company)
                .filter((key) => key.startsWith("custom-"))
                .reduce((obj, key) => {
                    obj[key] = company[key];
                    return obj;
                }, {});

            const companyAttributes = {
                id: company.id,
                type: company.type,
                primary_user_id: company.primary_user_id,
                supplier_code: company.supplier_code,
                name: company.name,
                phone: company.phone,
                email: company.email,
                status: company.status,
                registration_number: company.registration_number,
                code: company.code,
                warehouse_id: company.warehouse_id,
                heineken_distributor_code: company.heineken_distributor_code,
                heineken_ucc: company.heineken_ucc,
                analysis_code: company.analysis_code,
                agency_code: company.agency_code,
                debtor_code: company.debtor_code,
                debtor_branch_code: company.debtor_branch_code,
                category: company.category,
                currency: company.currency,
                remark: company.remark,
                to_block: company.to_block,
                prepaid_credits: company.prepaid_credits,
                price_tags: company.price_tags,
                price_tag_sources: company.price_tag_sources,
                rep_user_ids: company.rep_user_ids,
                payment: company.payment,
                shipping_addresses: company.shipping_addresses,
                attachments: company.attachments,
                user_meta: company.user_meta,
                credit: company?.credit,
                credit_term_code: company?.credit_term_code,
                overdue_limit: company.overdue_limit,
                tiers: company.tiers ?? company.tier_ids,
                representatives: company.representatives,
                primary_user: company.primary_user,
                mango_credit: company.mangoCredit,
                billing_address: company.billing_address,
                tax_exempted: company.tax_exempted,
                currency_symbol: company.currency_symbol,
                payment_methods: company.payment_methods,
                customer_payment_methods: company.customer_payment_methods,
                ...customFields,
                bo_can_delete: true,
                show_action_menu: true,
                representatives: company.representatives,
            };

            return companyAttributes;
        },

        _userMapper(user) {
            return {
                id: user.id,
                agent_code: user.agent_code,
                agent_branch_code: user.agent_branch_code,
                email: user.email,
                email2: user.email2,
                email_pending: user.email_pending,
                phone: user.phone,
                ic: user.ic,
                passport: user.passport,
                phone_pending: user.phone_pending,
                first_name: user.first_name,
                last_name: user.last_name,
                roles: user.roles,
                capabilities: user.capabilities,
                device_id: user.device_id,
                bo_can_delete: true,
                show_action_menu: true,
            };
        },

        parseCompany(company) {
            return CompanyFactory.construct(this.createMapperParameter(new CompanyMapperParameter()), company);
        },

        parseCompanies(companies) {
            let parsedCompanies = [];

            companies.forEach((companyData) => {
                const company = this.parseCompany(companyData);
                parsedCompanies.push(company);
            });
            return parsedCompanies;
        },

        getCompanies(url, payload, success, failure) {
            return this.getData(
                url,
                payload,
                (response) => {
                    success(this.parseCompanies(response.data.data), response.data.meta);
                },
                failure
            );
        },

        getCompany(id, url, payload, success, failure) {
            return this.getData(
                url + "/" + id,
                payload,
                (response) => {
                    success(this.parseCompany(response.data));
                },
                failure
            );
        },

        createCompany(url, payload, success, failure) {
            return this.postData(
                url,
                payload,
                (response) => {
                    success(this.parseCompany(response.data));
                },
                failure
            );
        },

        updateCompany(id, url, payload, success, failure) {
            return this.postData(
                `${url}/${id}`,
                payload,
                (response) => {
                    success(this.parseCompany(response.data));
                },
                failure
            );
        },

        createOrUpdateCompany(id = null, url, payload, success, failure) {
            if (id == null) {
                return this.createCompany(url, payload, success, failure);
            } else {
                return this.updateCompany(id, url, payload, success, failure);
            }
        },
    },
};
